import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-common-layout',
    templateUrl: './common-layout.component.html',
    imports: [RouterOutlet]
})
export class CommonLayoutComponent {
}
